import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material';

@Component({
    selector: 'app-error-toast',
    template: `Error: {{ errMsg }} <span class="mdi mdi-close-circle-o"></span>`,
    styles: [`span {
        color: #ea4335;
        float: right;
        font-size: 20px;
        position: absolute;
        right: 10px;
        top: 14px;}`
    ]
})
export class ErrorToastComponent {
    constructor( @Inject(MAT_SNACK_BAR_DATA) public errMsg: any) { }
}

@Component({
    selector: 'app-warning-toast',
    template: `Warning: {{ errMsg }} <span class="mdi mdi-close-circle-o"></span>`,
    styles: [`span {
        color: #ea4335;
        float: right;
        font-size: 20px;
        position: absolute;
        right: 10px;
        top: 14px;}`
    ]
})
export class WarningToastComponent {
    constructor( @Inject(MAT_SNACK_BAR_DATA) public errMsg: any) { }
}
